import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Body } from 'js/design_system/Body';
import { keptAlivePost } from 'js/utils/kept_alive_post';

export const socialTopicsTagUser = async () => {
  const resp = await keptAlivePost(
    routes.api_v0_community_tag_user_path({ subdomain_param: 'api' }),
    {},
  );

  if (!resp?.ok) {
    console.error('Failed to tag user with social topics');
  }
};

export const FocusTextContainer = styled.div`
  padding: 0 16px 0px 16px;

  @include breakpoint(medium) {
    padding: 0 16px 32px 16px;
  }

  @include breakpoint(large) {
    padding: 0 56px 0 0;
  }
`;

export const FocusText = styled.p`
  @import 'stylesheets/design_system/font.scss';

  @include serif__large;

  @include breakpoint(small, medium) {
    @include serif__medium;
  }

  margin: 0;
  color: var(--brand-colors-neutral-black);

  &:not(:last-child) {
    margin-bottom: var(--spacing-xs-16);
  }
`;

export const FocusTextSubheading = styled(Body)`
  @import 'stylesheets/design_system/font.scss';

  @include serif__medium;

  @include breakpoint(small, medium) {
    @include sans_serif__small;
  }
`;

export const ContentContainer = styled.div`
  padding: 24px 16px 40px 16px;

  @include breakpoint(large) {
    padding: 40px 40px 0 40px;
  }
`;

export const Why = styled.p`
  @import 'stylesheets/design_system/font.scss';

  @include body__medium;

  color: var(--text-primary, #141413);
  font-weight: 600;

  margin: 0;
  padding-bottom: var(--spacing-sm-24);
  color: #000;

  @include breakpoint(small, medium) {
    @include sans-serif__small;
  }
`;

export const Prompt = styled(Body)`
  padding-bottom: var(--spacing-xs-16);
  font-size: var(--type-body-md-size);
  line-height: var(--type-body-md-line-height);
  font-weight: 600;

  @include breakpoint(large) {
    font-size: var(--type-body-lg-size);
    line-height: var(--type-body-lg-line-height);
  }
`;
